var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCouponIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4732_565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 1.06439H9.45946C9.07081 1.06439 8.69756 1.21912 8.42257 1.49411L0.429534 9.48568C-0.143178 10.0584 -0.143178 10.9868 0.429534 11.5602L6.57024 17.7009C7.14295 18.2736 8.07131 18.2736 8.64403 17.7009L16.6371 9.70933C16.912 9.43361 17.0668 9.06036 17.0668 8.67097V2.531C17.0668 1.7207 16.4105 1.06439 15.6002 1.06439ZM13.0336 6.19753C12.4264 6.19753 11.9336 5.70475 11.9336 5.09757C11.9336 4.4904 12.4264 3.99762 13.0336 3.99762C13.6408 3.99762 14.1336 4.4904 14.1336 5.09757C14.1336 5.70475 13.6408 6.19753 13.0336 6.19753Z",
    fill: "#572148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5334 2.53101L18.5327 9.35735C18.5327 9.6954 18.3985 10.0203 18.1587 10.2593L10.0366 18.3814L10.1613 18.5061C10.734 19.0788 11.6624 19.0788 12.2351 18.5061L19.5696 11.173C19.8453 10.898 20 10.5248 20 10.1361V3.99762C20 3.18731 19.3437 2.53101 18.5334 2.53101Z",
    fill: "#572148"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4732_565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCouponIcon);
export default __webpack_public_path__ + "static/media/NewCouponIcon.285b10305e1fb0e5478980741ab661d8.svg";
export { ForwardRef as ReactComponent };